export default __webpack_public_path__ + "static/media/tilt-phone.7f363c39.png";